import * as React from 'react';
import { Button } from '../../../../components/ui/button';
import { cn } from '../../../../components/ui';
import { Sparkles, TrendingUp, Zap } from 'lucide-react';

const SUGGESTIONS = [
  {
    text: 'Analyze my data trends',
    icon: TrendingUp,
    description: 'Discover patterns and insights',
    color: 'from-blue-500/20 to-cyan-500/20 text-blue-600'
  },
  {
    text: 'Find unusual patterns',
    icon: Sparkles,
    description: 'Detect outliers and anomalies',
    color: 'from-purple-500/20 to-pink-500/20 text-purple-600'
  },
  {
    text: 'Quick data summary',
    icon: Zap,
    description: 'Get key statistics instantly',
    color: 'from-amber-500/20 to-orange-500/20 text-amber-600'
  }
];

interface ChatSuggestionsProps {
  className?: string;
  onSuggestionClick: (args: { suggestion: string; openTrigger: 'chat_suggestion' }) => void;
}

export function ChatSuggestions({ className, onSuggestionClick }: ChatSuggestionsProps) {
  return (
    <div className={cn("p-3 space-y-2 bg-card/50", className)}>
      <p className="text-sm font-medium text-muted-foreground mb-2">Try one of these:</p>
      <div className="grid gap-2">
        {SUGGESTIONS.map((suggestion) => {
          const Icon = suggestion.icon;
          return (
            <Button
              key={suggestion.text}
              onClick={() => onSuggestionClick({ suggestion: suggestion.text, openTrigger: 'chat_suggestion' })}
              variant="outline"
              className={cn(
                "flex items-center gap-2 w-full py-2 px-3 h-auto text-left",
                "bg-gradient-to-r hover:bg-gradient-to-br transition-colors",
                suggestion.color
              )}
            >
              <div className="flex-shrink-0 w-6 h-6 rounded-md bg-white/80 flex items-center justify-center">
                <Icon className="w-3.5 h-3.5" />
              </div>
              <div>
                <div className="font-medium text-sm">{suggestion.text}</div>
                <div className="text-xs text-muted-foreground/80">{suggestion.description}</div>
              </div>
            </Button>
          );
        })}
      </div>
    </div>
  );
} 